import React from "react";

import { DupontTooltip } from "components/DupontTooltip";

import ErrorIcon from "assets/Banner/error-icon.svg";
import InfoIcon from "assets/Banner/info-icon.svg";
import WarningIcon from "assets/Banner/warning-icon.svg";
import CancelIcon from "assets/SvgIcon/Cancel";

import "./index.scss";

const ScreenStatusBox = props => {
  const { message, className, onClose, type, tooltip } = props;
  const closeHandler = () => onClose(false);
  const ICONS = {
    info: InfoIcon,
    warning: WarningIcon,
    error: ErrorIcon
  };

  const getContent = () => (
    <div className={`screen-notification ${className || ""} ${type}`}>
      <img className="screen-notification--icon" src={ICONS[type]} alt="icon" />
      <div>{message}</div>
      <i className="screen-notification--close" onClick={closeHandler}>
        <CancelIcon type={type} />
      </i>
    </div>
  );

  const getTemplateWithTooltip = () => (
    <DupontTooltip type={type} title={tooltip}>
      {getContent()}
    </DupontTooltip>
  );

  return tooltip ? getTemplateWithTooltip() : getContent();
};

export default ScreenStatusBox;
